import React, { Component } from 'react';
class Main extends Component {
    componentDidMount() {
        require("./css/Main.css");
    }
    render() {
        return(
            <div className="Main_Container">
                    {this.props.Title?<h3 className="Main_Title">{this.props.Title}</h3>:""}
                    {this.props.Description?<p className="Main_Description">{this.props.Description}</p>:""}
                    {this.props.children}
            </div>
        )
    }
}
export default Main;